import {Injectable} from "@angular/core";
import { Subject } from 'rxjs';

@Injectable()
export class SidebarService {
  // private activate = new Subject<number>();
  // active = this.activate.asObservable();
  updateActive(active: number) {
    // this.activate.next(active);
  }
}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/main/sidebar/sidebar.service.ts